/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function () {

  //   // Below are example event listeners.  They listen for theme events that Pipeline
  //   // fires in order to make it easier for you to add customizations.

  //   // Keep your scripts inside this IIFE function call to avoid leaking your
  //   // variables into the global scope.


  //   document.addEventListener('theme:variant:change', function(event) {
  //     // You might use something like this to write a pre-order feature or a
  //     // custom swatch feature.
  //     var variant = event.detail.variant;
  //     var container = event.target;
  //     if (variant) {
  //       console.log('Container ———————— ↓');
  //       console.log(container);
  //       console.log('Variant —————————— ↓');
  //       console.log(variant);
  //       // ... update some element on the page
  //     }
  //   });

  //   document.addEventListener('theme:cart:change', function(event) {
  //     var cart = event.detail.cart;
  //     if (cart) {
  //       console.log('Cart ———————————— ↓');
  //       console.log(cart);
  //       // ... update an app or a custom shipping caluclator
  //     }
  //   });
  //   // Fired when page loads to update header values
  //   document.addEventListener('theme:cart:init', (e) => {
  //     console.log('theme:cart:init');
  //     console.log(e);
  //   });

  //   // Debounced scroll listeners.  Up and down only fire on direction changes
  //   // These events are useful for creating sticky elements and popups.
  //   document.addEventListener('theme:scroll', e => { console.log(e); });
  //   document.addEventListener('theme:scroll:up', e => { console.log(e); });
  //   document.addEventListener('theme:scroll:down', e => { console.log(e); });

  //   // Debounced resize listener to bundle changes that trigger document reflow
  //   document.addEventListener('theme:resize', e => { console.log(e); });

  //   // Locks and unlocks page scroll for modals and drawers
  //   // These are commented out because firing them will lock the page scroll
  //   // the lock event must set `detail` to the modal or drawer body so the
  //   // scroll locking code knows what element should maintain scoll.
  //   // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  //   // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  //   // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  //   // variables into the global scope.


  if (document.querySelector('.product__block__description_mobile')) {
    const setBlockDescription = (width) => {
      if (width < 768) {
        document.querySelector('.product__block__description_mobile').appendChild(document.querySelector('.product__block__description'));
      } else {
        document.querySelector('.product__custom__description').appendChild(document.querySelector('.product__block__description'));
      }
    }

    let windowWidth = document.body.clientWidth;
    setBlockDescription(windowWidth);

    addEventListener("DOMContentLoaded", (event) => {
      windowWidth = document.body.clientWidth;
      setBlockDescription(windowWidth);
    });

    addEventListener("resize", (event) => {
      windowWidth = document.body.clientWidth;
      setBlockDescription(windowWidth);
    });
  }

  // Scroll slider

  if (document.querySelector('.subcollections.subcollections__desktop-slider .subcollections__inner .subcollection__item')) {

    const subcollectionItem = document.querySelector('.subcollections.subcollections__desktop-slider .subcollections__inner .subcollection__item'),
          subcollectionItemAll = document.querySelectorAll('.subcollections.subcollections__desktop-slider .subcollections__inner .subcollection__item');

    function _getWidth(el, type) {
      if (type === 'inner') // .innerWidth()
        return el.clientWidth;
      else if (type === 'outer') // .outerWidth()
        return el.offsetWidth;
      let s = window.getComputedStyle(el, null);
      if (type === 'width') // .width()
        return el.clientWidth - parseInt(s.getPropertyValue('padding-left')) - parseInt(s.getPropertyValue('padding-right'));
      else if (type === 'full') // .outerWidth(includeMargins = true)
        return el.offsetWidth + parseInt(s.getPropertyValue('margin-left')) + parseInt(s.getPropertyValue('margin-right'));
      return null;
    }

    let subcollectionInner =  document.querySelector('.subcollections.subcollections__desktop-slider .subcollections__inner'),
        subcollectionItemWidth = _getWidth(subcollectionItem, 'full'),
        subcollectionMaxWidth = subcollectionItemWidth * (subcollectionItemAll.length - 3),
        scrollAmount = 0,
        scrollMax = subcollectionItemWidth,
        scrollMin = 0;

    document.querySelector('.subcollections.subcollections__desktop-slider .subcollections__next > button').onclick = function () {

      let scrollToAt = scrollAmount += subcollectionItemWidth;

      if (scrollToAt >= subcollectionMaxWidth) {
        scrollAmount = subcollectionMaxWidth;
        scrollToAt = subcollectionMaxWidth;
      }

      subcollectionInner.scrollTo({
        top: 0,
        left: scrollToAt,
        behavior: 'smooth'
      });
    };

    document.querySelector('.subcollections.subcollections__desktop-slider .subcollections__prev > button').onclick = function () {

      let scrollToAt = scrollAmount -= subcollectionItemWidth;
      if (scrollToAt <= 0) {
        scrollAmount = 0;
        scrollToAt = 0;
      }

      subcollectionInner.scrollTo({
        top: 0,
        left: scrollToAt,
        behavior: 'smooth'
      });
    };
  }

})();


